<template>
  <div>
    <img
      :src="image"
      class="h-100vh w-auto c-pointer"
      @click.prevent="onClick"
    >
  </div>
</template>

<script>
export default {
  name: 'Zoom-Foto',
  props: ['image'],
  data () {
    return {
    }
  },
  methods: {
    onClick () {
      this.$emit('handleClose', this.image)
    }
  }
}
</script>
